export const humanDatetime = (value) => {
  const date = value.substring(0, 10);
  const time = value.substring(11, 16);
  return `${date} ${time}`;
};


// WEBPACK FOOTER //
// ./src/common/tenancy/datetime.js